import { JobStatus } from "./job"

class JobStatusUtilsClass {
  private static instance: JobStatusUtilsClass

  private constructor() {}

  public static getInstance(): JobStatusUtilsClass {
    if (!JobStatusUtilsClass.instance) {
      JobStatusUtilsClass.instance = new JobStatusUtilsClass()
    }

    return JobStatusUtilsClass.instance
  }

  isStatusAtOrPast(currentStatus: JobStatus, status: JobStatus) {
    const statusOrder = Object.values(JobStatus)

    const currentIndex = statusOrder.indexOf(currentStatus)
    const targetIndex = statusOrder.indexOf(status)

    if (currentIndex === -1 || targetIndex === -1) return false

    return currentIndex >= targetIndex
  }
}

export const JobStatusUtils = JobStatusUtilsClass.getInstance()
